/**

Copyright (c) 2018, MOBICOOP. All rights reserved.
This project is dual licensed under AGPL and proprietary licence.

This program is free software: you can redistribute it and/or modify
it under the terms of the GNU Affero General Public License as
published by the Free Software Foundation, either version 3 of the
License, or (at your option) any later version.
This program is distributed in the hope that it will be useful,
but WITHOUT ANY WARRANTY; without even the implied warranty of
MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE. See the
GNU Affero General Public License for more details.
You should have received a copy of the GNU Affero General Public License
along with this program. If not, see gnu.org/licenses.

Licence MOBICOOP described in the file
LICENSE
**************************/

<template>
  <ion-page class="ion-page">
    <ion-header class="ion-no-border">
      <ion-toolbar color="primary">
        <ion-buttons slot="start">
          <ion-back-button></ion-back-button>
        </ion-buttons>
        <h1 class="ion-text-center">{{ $t('HitchHiking.register.title')}}</h1>
      </ion-toolbar>
    </ion-header>

    <ion-content color="primary" forceOverscroll="false" class="no-scroll">
      <div class="mc-white-container" style="height: 100%;">
        <Slider :key="refresh" v-bind:slides="slides" v-on:save="register()"></Slider>
      </div>
    </ion-content>
  </ion-page>
</template>

<style lang="scss">
</style>

<script>
import Slider from "../../Shared/View/Slider.view";
import { toast } from "../../Shared/Mixin/toast.mixin";
import HitchHikingRegisterStep1 from "../../HitchHiking/RegisterHitchHiking/HitchHikingRegisterStep1.view";
import HitchHikingRegisterStep2 from "../../HitchHiking/RegisterHitchHiking/HitchHikingRegisterStep2.view";
import HitchHikingRegisterStep3 from "../../HitchHiking/RegisterHitchHiking/HitchHikingRegisterStep3.view";
import {shallowRef} from "vue";

export default {
  name: "register",
  mixins: [toast],
  components: {
    Slider
  },
  data() {
    return {
      slides: [
        { title: "", component: shallowRef(HitchHikingRegisterStep1) },
        { title: "", component: shallowRef(HitchHikingRegisterStep2) },
        { title: "", component: shallowRef(HitchHikingRegisterStep3) }
      ],
      refresh: 0
    };
  },
  created() {
    this.$store.commit("init_sliderloader_visibility");
    if (!this.user) {
      this.$store.commit("register_reset");
      this.$store.commit("hitch_hicking_reset");
    }
  },
  computed: {
    user: {
      get() {
        return this.$store.state.registerStore.userToRegister;
      },
      set() {
        this.$store.commit("register_update", this.user);
      }
    },
    identityFile: {
      get() {
        return this.$store.state.hitchHikingStore.identityFile;
      },
    }
  },

  methods: {
    register() {
      const email = this.$store.state.registerStore.userToRegister.email;
      const file = this.identityFile;
      this.$store.commit("change_sliderloader_visibility");
      this.$store.dispatch("register").then(res => {
          let username = this.$store.state.registerStore.userToRegister.email;
          let password = this.$store.state.registerStore.userToRegister.password;
          this.$store.dispatch('login', { username, password })
          //  .then( res => Promise.resolve(res), err => Promise.reject(err) )
          .then(res => {
            if (file && file.name) {
              this.$store.dispatch('hitch_hicking_sendVerifId', { file: file }).then(() => {
                this.finishRegister(email, file);
              }).catch(err => {
                console.log(err);
              });
            } else {
              this.finishRegister(email, file);
            }
           })
          .catch(err => {
            this.$store.dispatch('logout');
            this.presentToast(this.$t("Commons.error"), "danger");
            this.$store.commit("change_sliderloader_visibility");
          })
        }).catch(err => {
          this.presentToast(this.$t("Commons.error"), "danger");
          this.$store.commit("change_sliderloader_visibility");
        });
    },
    finishRegister(email, file) {
      this.$store.commit("register_reset");
      this.$store.commit("register_reset");
      this.$store.commit("hitch_hicking_reset");
      this.$store.dispatch('logout');
      this.$router.push({name: 'hitchHiking.home'});
      this.$router.push({path: "/hitchhiking/confirm-registration/" + email});
      this.presentToast(this.$t("Register.success"), "success");
      this.$store.commit("change_sliderloader_visibility");
      // reload the component
      this.refresh++
    }
  }
};
</script>
